import { LanguageCode } from '@osmosis/shared/languages';
import { groupNames } from '../../constants/formatMesage';
import { IntlShape } from 'react-intl';

/**
 * Format library name.
 */
export const formattedGroupName = (name: string) => {
  // logged out libraries don't need info icon for now
  return name.includes('ⓘ') ? name.slice(0, name.length - 1) : name;
};

/**
 * Format data id.
 */
export const formattedDataId = (l1Name?: string, l2Name?: string) => {
  return `${formatStringDataId(l1Name)}_${formatStringDataId(l2Name)}`;
};

/**
 * Format string data id.
 */
export const formatStringDataId = (str = '') => {
  return str.toLowerCase().replace(/\s/g, '-');
};

/**
 * FormattedUrl.
 */
export const formattedUrl = (
  l6Name: string,
  {
    language = LanguageCode.EN,
  }: {
    language?: LanguageCode;
  },
) => {
  const langPrefix = language === LanguageCode.ES ? 'es/' : '';

  return `/learn/${langPrefix}${l6Name.replace(/\//g, '').replace(/\s/g, '_')}`;
};

/**
 * Translates a group name into a localized string using the provided internationalization object.
 * @param groupName - The name of the group to be translated.
 * @param intl - The internationalization object used to format the message.
 * @returns The translated group name if a corresponding message is found; otherwise, the original group name.
 */
export const translateGroupName = (
  groupName: string,
  intl: IntlShape,
): string => {
  const normalizedKey = groupName.toLowerCase().replace(/\s+/g, '');
  const message = groupNames[normalizedKey as keyof typeof groupNames];

  return message ? intl.formatMessage(message) : groupName;
};
